@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.body {
  width: 700px;
  padding: 16px;

  .explanation {
    line-height: 1.3;
    margin-bottom: 30px;
  }
  .confirmation {
    line-height: 1.3;
    font-weight: @bold;
  }

  .loading-indicator {
    height: 80px;
  }

  .results-header {
    font-size: 20px;
    line-height: 1.25;
    margin-bottom: 8px;
  }

  .grid {
    display: grid;
    grid-template-columns: auto auto;
    border: 1px solid @shipping--default--border-color;
    border-bottom: none;
    margin-bottom: 20px;

    .cell {
      font-size: 14px;
      line-height: 1.5;
      padding: 8px 0 8px 8px;
      border-bottom: 1px solid @shipping--default--border-color;
    }

    .header {
      .cell();
      background-color: @shipping--default--background-color;
      padding: 12px 0 12px 8px;
    }
  }
}

.footer {
  display: flex;
  justify-content: flex-end;
  padding: 8px;
}
